import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class PurchaseTypeRuleService {
    constructor(http) {
        this.http = http;
        this.singular = 'purchase type rule';
        this.plural = 'purchase type rules';
        this.editor = PLATFORM.moduleName('pages/quote-setup/purchase-type-rules/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`purchase-type-rules/filter/${loadOptions}`);
        return await response.json();
    }

    async create(purchaseTypeRule) {
        await this.http.fetch('purchase-type-rules', { method: 'POST', body: json(purchaseTypeRule) });
    }

    async update(purchaseTypeRule) {
        await this.http.fetch(`purchase-type-rules/${purchaseTypeRule.id}`, { method: 'PUT', body: json(purchaseTypeRule) });
    }

    async delete(id) {
        await this.http.fetch(`purchase-type-rules/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`purchase-type-rules/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`purchase-type-rules/top-three/${query}`);
        return await response.json();
    }
}